//----------- REACT IMPORTS ------------//
import React, { useEffect } from "react";
//------ BOOTSTAP ITEMS IMPORTS -------//
import { Col, Container, Image, Row } from "react-bootstrap";
import { SplashLogo } from "../../../../../assets/images";
//----------- IMAGE IMPORTS -----------//

function SplashOneLab() {

    return (
        <div className="splash_screen_one">
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="splash_area_one">
                            <div className="splash_img">
                                <Image src={SplashLogo} alt="..." />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default SplashOneLab;
